import {
    getMeteringRecord,
    listMeteringRecords
} from './queries';
import {
    createMeteringRecord,
    deleteMeteringRecord,
    updateMeteringRecord,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeteringRecord} from "../types.ts";
import {generateClient} from "aws-amplify/api";
import {stripReadonlyFields} from '../../../utils/stripReadonlyFields';
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";

import {ListRecordsQuery} from "../../../types";

export type ListMeteringRecords = {
    listMeteringRecords: { items: MeteringRecord[], nextToken: string }
}

export type GetMeteringRecord = {
    getMeteringRecord: MeteringRecord
}

export type CreateMeteringRecord = {
    createMeteringRecord: MeteringRecord
}

export type UpdateMeteringRecord = {
    updateMeteringRecord: MeteringRecord
}

export type DeleteMeteringRecord = {
    deleteMeteringRecord: string
}


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListMeteringRecords>>({
            query: listMeteringRecords,
            variables: {...query},
        });
        return {
            items: response.data?.listMeteringRecords.items,
            nextToken: response.data?.listMeteringRecords.nextToken,
        };
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetMeteringRecord>>({
            query: getMeteringRecord,
            variables: {id: id},
        });
        return response.data?.getMeteringRecord;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const add = async (payload: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<CreateMeteringRecord>>({
            query: createMeteringRecord,
            variables: {input: payload},
        });
        notifySuccess('Record added successfully');
        return response.data?.createMeteringRecord;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const update = async (_id: string, record: MeteringRecord) => {
    const payload = stripReadonlyFields(record);
    try {
        const response = await client.graphql<GraphQLQuery<UpdateMeteringRecord>>({
            query: (updateMeteringRecord),
            variables: {input: payload},
        });
        notifySuccess('Record updated successfully');
        return response.data?.updateMeteringRecord;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteMeteringRecord>>({
            query: (deleteMeteringRecord),
            variables: {input: {id: id}},
        });
        notifySuccess('Record deleted successfully');
        return response.data?.deleteMeteringRecord;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};
